export default __webpack_public_path__ + "img/opel-logo.1d5bb17a.png";